const getters = {
  loginStatus: (state) => {
    return state.loginStatus || sessionStorage.getItem('loginStatus')
  },
  loginType: (state) => {
    return state.loginType || sessionStorage.getItem('loginType')
  },
  managerRouter: (state) => state.managerRouter,
  companyName: (state) => {
    return state.companyName || sessionStorage.getItem('companyName')
  },
  companyList: (state) => {
    let _list = []
    if (state.companyList.length > 0) {
      _list = state.companyList
    } else {
      let companyList = JSON.parse(sessionStorage.getItem('companyList'))
      if (companyList) {
        _list = companyList
      }
    }
    return _list
  },
}
export default getters
